import { LayoutDashboard, School, Users, Building2, ClipboardList } from "lucide-react";

/**
 * Single source of truth for dashboard navigation.
 * DashboardNav.jsx and the mobile bottom nav in dashboard-layout.jsx
 * import from here - they can never diverge.
 *
 * short: abbreviated label for the mobile nav where space is tight.
 */
export const NAV_ITEMS = [
  { name: "Dashboard",          short: "Home",    path: "/dashboard",            icon: LayoutDashboard },
  { name: "My School",          short: "Schools", path: "/schools",              icon: Building2 },
  { name: "My Gradebooks",      short: "Marks",   path: "/gradebooks",           icon: ClipboardList },
  { name: "My Report Folders",  short: "Folders", path: "/report-folders",       icon: School },
  { name: "Shared Folders",     short: "Shared",  path: "/shared-report-folders", icon: Users },
];
